module.exports = __webpack_public_path__ + "img/mingbai1_c86fe6ed2.png";